<template>
  <div class="box-wrapper">
    <div
      class="label"
      v-if="bLabel"
      :style="{
        top: bTop - 10 + 'px',
        left: bLeft + 'px',
        width: bWidth + 4 + 'px',
      }"
    >
      {{ bLabel }}
    </div>
    <a
      class="box-delete"
      v-on:click="removeMyself"
      v-if="bActive"
      :style="{
        top: bTop - 18 + 'px',
        left: bLeft + bWidth - 15 + 'px',
      }"
    >
      <img src="@/assets/cross.svg" alt="" />
    </a>
    <div
      class="box"
      :style="{
        top: bTop + 'px',
        left: bLeft + 'px',
        width: bWidth + 'px',
        height: bHeight + 'px',
      }"
      v-bind:class="{ active: bActive }"
      @mousedown="selectBox"
    ></div>
  </div>
</template>

<script>
export default {
  name: "Box",
  props: [
    "b-top",
    "b-left",
    "b-width",
    "b-height",
    "on-select",
    "b-active",
    "b-index",
    "on-delete",
    "b-label",
  ],
  methods: {
    selectBox() {
      this.onSelect(this.bIndex);
    },
    removeMyself() {
      this.onDelete(this.bIndex);
    },
  },
};
</script>

<style lang="scss" scoped>
.box {
  position: absolute;
  border: 2px #00deab dashed;
  &:hover,
  &.active {
    background-color: rgba(0, 222, 171, 0.2);
  }
  z-index: 3;
}
.box-delete {
  position: absolute;
  z-index: 6;
  cursor: pointer;
}

.box-delete img {
  background-color: #fefefe;
  border: 1px solid #ebebef;
  padding: 3px;
  border-radius: 100px;
  width: 30px;
  &:hover {
    background-color: #ebebef;
  }
}

.label {
  position: absolute;
  height: 22px;
  font-size: 16px;
  color: #000;
  font-weight: bold;
  background-color: #90ee90;
  z-index: 4;
}

.active {
  border: 2px #00deab solid;
}
</style>
